export default __webpack_public_path__ + "static/media/frontdoor_house3.e35a8755.jpeg";